import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {HtmlUtilsService} from "../html-utils/html-utils.service";
import {Router} from "@angular/router";
import {HttpClient} from "@angular/common/http";
import {AuthService} from "../auth/auth.service";
import {first} from "rxjs/operators";

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  private recaptchaValidUrl = "portalApiUrl/omnis/recaptcha/validate";

  form!: FormGroup;
  highContrast = false;
  loading = false;
  submitted = false;
  showPassword = false;
  showPasswordPolicy = false;
  captchaResolved = false;
  registerSuccess = false;
  showAlert = false;
  token: string | undefined;

  constructor(private htmlUtils: HtmlUtilsService,
              private route: Router,
              private formBuilder: FormBuilder,
              protected http: HttpClient,
              private authService: AuthService) {
    this.token = undefined;
    this.highContrast = this.htmlUtils.contrast;
    this.htmlUtils.highContrast.subscribe((value) => {
      if (value !== this.highContrast) {
        this.highContrast = value;
      }
    });
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: new FormControl(
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ),
      password: new FormControl(
        '',
        [
          Validators.required,
          Validators.pattern(
            '^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[-+_!@#$%^&*.,?]).{10,}$'
          ),
        ],
      ),
      acceptTerms: new FormControl(false, Validators.requiredTrue),
      recaptcha: null
    });
  }

  onSubmit() {
    this.submitted = true;
    const acceptedConsents = ['TERMS_AND_CONDITIONS', 'RODO_PRIVACY_POLICY'];

    if (this.form.invalid) {
      return;
    }

    this.loading = true;

    this.authService
      .register({
        email: this.formField.email.value.trim(),
        password: this.formField.password.value.trim(),
        acceptedConsents: acceptedConsents,
      })
      .pipe(first())
      .subscribe(
        () => {
          this.showAlert = true;
          this.registerSuccess = true;
          this.loading = false;
          setTimeout(() => {
            this.goToLogin();
          }, 5000);
        },
        (error) => {
          this.loading = false;
          this.showAlert = true;
          this.registerSuccess = false;
        }
      );
  }

  get formField() {
    return this.form.controls;
  }

  cancel() {
    this.route.navigateByUrl('/login');
  }

  goToLogin() {
    this.route.navigateByUrl('/login');
  }

  togglePasswordInfo() {
    this.showPasswordPolicy = !this.showPasswordPolicy;
  }

  checkCaptcha(captchaResponse: string) {
    if (!captchaResponse || captchaResponse.length == 0) {
      this.captchaResolved = false;
    } else {
      this.http.post<boolean>(this.recaptchaValidUrl, {}, {params: {captchaResponse: captchaResponse}})
        .subscribe(
          result => {
            this.captchaResolved = result;
          },
          error => {
            this.captchaResolved = false;
          }
        )
    }
  }

  toggleShow() {
    this.showPassword = !this.showPassword;
  }
}
